import React, { useContext, useEffect, useMemo } from 'react'
import { Loan } from '@matech/thebigpos-sdk'
import { useLoanContext } from './LoanContext'
import { useLoanSignalRContext } from './LoanSignalRContext'

export type LoanLockedContextValue = {
	isLocked: boolean
}

export type LoanLockedContextProviderProps = {
	children: React.ReactNode
}

const defaultContextValues: LoanLockedContextValue = {
	isLocked: false,
}

export const LoanLockedContext = React.createContext(
	defaultContextValues
)

export const LoanLockedContextProvider = ({
	children,
}: LoanLockedContextProviderProps) => {
	const { loan } = useLoanContext()

	const { useSignalREffect } = useLoanSignalRContext()
	const [isLocked, setIsLocked] = React.useState(
		loan?.isLocked ?? false
	)

	useEffect(() => {
		setIsLocked(loan?.isLocked ?? false)
	}, [loan?.isLocked])

	const handleLoanSave = (updatedLoan: Loan) => {
		if (loan?.id === updatedLoan.id) {
			setIsLocked(updatedLoan.isLocked)
		}
	}

	// @ts-ignore
	useSignalREffect<string, Loan>('LoanSave', handleLoanSave)

	const value = useMemo(() => ({ isLocked }), [isLocked])
	return (
		<LoanLockedContext.Provider value={value}>
			{children}
		</LoanLockedContext.Provider>
	)
}

export const useLoanLockedContext = () =>
	useContext(LoanLockedContext)
